import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { useT } from "@/i18n";

export const SiteLayout = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return (
  <>
    <Navbar />
    <main><Outlet /></main>
    <Footer />
  </>
  );
};

export const PageHead = ({ eyebrow, title, sub, testid }) => {
  const { t } = useT();
  return (
  <section className="grain max-w-7xl mx-auto px-6 lg:px-10 pt-16 pb-10" data-testid={testid}>
    {eyebrow && <p className="label rise">{t(eyebrow)}</p>}
    <h1 className="text-4xl sm:text-5xl lg:text-6xl text-[#0F4C5C] max-w-3xl rise d1">{t(title)}</h1>
    {sub && <p className="mt-5 text-base md:text-lg text-gray-700 max-w-2xl rise d2">{t(sub)}</p>}
  </section>
  );
};

export const VerifyText = ({ text }) => {
  const parts = text.split(/(\[VERIFY[^\]]*\])/g);
  return <>{parts.map((p, i) => p.startsWith("[VERIFY") ? <span key={i} className="verify">{p}</span> : p)}</>;
};
